import { mapState } from 'vuex';


var faq = {
    en : [
        {
            caption : `What is Snippity?`,
            text : `Snippity is a fabulous app that tells children the news in simple words that are understandable at any age!`
        }
    ],
    ru : [
        {
            caption : `Что такое Snippity?`,
            text : `Snippity это сказочное приложение, которое рассказывает детям новости простыми словами, понятными с любого возраста! `
        }
    ]
}

export default {
    name: 'faq',
    props: {
    },

    data : function(){

        return {
            loading : false,
            faq : faq
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        faqL : function(state){
            return this.faq[state.locale] || this.faq.en
        }
    }),

    methods : {
        
    },
}